import { Group, UnstyledButton, Text } from '@mantine/core';
import {
  IconCrown,
  IconFlameFilled,
  IconShirtFilled,
  IconSwords,
  IconUsers,
  // IconBuildingStore,
  IconLayoutGridFilled,
  IconDeviceGamepad2,
} from '@tabler/icons-react';
import { useLocation, useNavigate } from 'react-router';
import { translate } from '@/lib';
import clsx from 'clsx';
import style from './BottomNav.module.scss';
import { IconGun } from '@/components/Icons/IconGun';
import { IconCostume } from '@/components/Icons/IconCostume';
import { BottomNavMore } from './BottomNavMore';
import { BottomNavGroup } from './BottomNavGroup';
import { isNavItemActive, type NavItem } from './bottomNavTypes';

const VISIBLE_NAV_COUNT = 5;

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (path: string) => {
    if (isNavItemActive(path, location.pathname)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate(path);
    }
  };

  const navItems: NavItem[] = [
    {
      icon: <IconFlameFilled size={24} />,
      label: 'Hot',
      path: '/',
      translationKey: 'ff.nav.hot',
    },
    {
      icon: <IconLayoutGridFilled size={24} />,
      label: 'Items',
      path: 'group-items',
      translationKey: 'ff.nav.items',
      children: [
        {
          icon: <IconShirtFilled size={24} />,
          label: 'Outfits',
          path: '/outfits',
          translationKey: 'ff.nav.outfits',
        },
        {
          icon: <IconGun color={location.pathname === '/guns' ? 'active' : 'default'} />,
          label: 'Guns',
          path: '/guns',
          translationKey: 'ff.nav.guns',
        },
        {
          icon: <IconCostume color={location.pathname === '/collections' ? 'active' : 'default'} />,
          label: 'Collections',
          path: '/collections',
          translationKey: 'ff.nav.collections',
        },
      ],
    },
    {
      icon: <IconCrown size={24} />,
      label: 'Collectibility',
      path: '/collectibility',
      translationKey: 'ff.nav.collectibility',
    },
    {
      icon: <IconDeviceGamepad2 size={24} />,
      label: 'Playstyles',
      path: 'group-playstyles',
      translationKey: 'ff.nav.playstyles',
      children: [
        {
          icon: <IconSwords size={24} />,
          label: 'Skill Combos',
          path: '/skill-combos',
          translationKey: 'ff.nav.skillCombos',
        },
        {
          icon: <IconUsers size={24} />,
          label: 'Characters',
          path: '/characters',
          translationKey: 'ff.nav.characters',
        },
      ]
    },
    // {
    //   icon: <IconBuildingStore size={24} />,
    //   label: 'Market',
    //   path: '/market',
    //   translationKey: 'ff.nav.market',
    // },
    // {
    //   icon: <IconTool size={24} />,
    //   label: 'Tools',
    //   path: '/tools',
    //   translationKey: 'ff.nav.tools',
    // },
  ];

  const visibleItems = navItems.slice(0, VISIBLE_NAV_COUNT);
  const overflowItems = navItems.slice(VISIBLE_NAV_COUNT);

  return (
    <nav className={style.bottomNav}>
      <Group justify="space-around" h="100%" wrap="nowrap">
        {visibleItems.map((item) => {
          if (item.children) {
            return (
              <BottomNavGroup
                key={item.path}
                item={item}
                currentPath={location.pathname}
                onNavigate={handleNavClick}
              />
            );
          }

          const isActive = isNavItemActive(item.path, location.pathname);
          return (
            <UnstyledButton
              key={item.path}
              onClick={() => handleNavClick(item.path)}
              className={clsx(style.navItem, { [style.active]: isActive })}
            >
              <div className={style.navIcon}>{item.icon}</div>
              <Text size="xs" className={style.navLabel}>
                {translate(item.translationKey, item.label)}
              </Text>
            </UnstyledButton>
          );
        })}
        {overflowItems?.length > 0 && (
          <BottomNavMore
            items={overflowItems}
            currentPath={location.pathname}
            onNavigate={handleNavClick}
          />
        )}
      </Group>
    </nav>
  );
}

export default BottomNav;

